import { loadStripe } from '@stripe/stripe-js';
import { readConfig } from '@monorepo/common';

/**
 * Module-level Stripe singleton.
 *
 * `loadStripe` must run exactly once, outside React render, so the Stripe.js
 * script is fetched a single time for the whole SPA. This used to live in
 * `src/index.tsx` behind a global <Elements>; the Payment Element migration
 * moves it here so every payment step can bring its own <Elements> instance
 * (each keyed to its own clientSecret) without a page-wide Elements ancestor.
 */
export const stripePromise = loadStripe(readConfig().stripeKey);

export default stripePromise;
